export default "__VITE_ASSET__d1LBnczq__"